import { useEffect, useRef } from "react";
import { FaXmark } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { getSheetControls } from "../../WorkbookControllingSlice";
import { useGetSqlQueryMutation } from "../../dataApiSlice";
import { FaRegCopy } from "react-icons/fa";

export default function SQLQueryModal({ closeModal, currentSheet }) {
  const modalRef = useRef(null);
  const reduxQueryBody = useSelector(
    getSheetControls({ Sheetid: currentSheet.Sheetid, key: "queryBody" })
  );
  const [
    getSqlQuery,
    {
      data: sqlQuery,
      isLoading: isSqlQueryLoading,
      isSuccess: isSqlQuerySuccess,
      isError: isSqlQueryError,
      error: sqlQueryError,
    },
  ] = useGetSqlQueryMutation();
  const query = isSqlQuerySuccess && sqlQuery?.sql ? sqlQuery.sql : null;
  //   console.log(query);
  useEffect(() => {
    if (reduxQueryBody) {
      getSqlQuery(reduxQueryBody);
    }
  }, [reduxQueryBody]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [closeModal]);

  const handleCopy = async () => {
    if (query) {
      await navigator.clipboard.writeText(query);
    }
  };
  return (
    <main className="fixed inset-0 flex items-center justify-center z-50 w-[60%] max-h-40 top-[10%] left-[20%]">
      <section
        className="flex flex-col bg-white shadow-2xl rounded w-full h-auto justify-between items-center gap-0"
        ref={modalRef}
      >
        <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg  font-medium">
          SQL Query
          <button onClick={closeModal}>
            <FaXmark />
          </button>
        </header>
        <div className="p-2 w-full h-[20vh] flex items-start justify-start">
          {isSqlQueryLoading ? (
            <p className="w-full h-full flex items-start justify-start">
              wait while query is generating...
            </p>
          ) : null}
          {isSqlQueryError && sqlQueryError ? (
            <p className="w-full h-full flex items-start justify-start">
              an error occured
            </p>
          ) : null}
          {query ? (
            <div className="relative w-full h-full">
              <button
                onClick={handleCopy}
                className="absolute right-2 top-2 text-white shadow-xl hover:shadow-none"
                title="Copy SQL"
              >
                <FaRegCopy />
              </button>
              <pre className="w-full h-full overflow-y-auto bg-gray-900 text-green-300 p-3 pr-4 rounded text-sm font-mono whitespace-pre-wrap border">
                {query}
              </pre>
            </div>
          ) : null}
        </div>
      </section>
    </main>
  );
}
